import { Image } from 'components/Image/Image';
/**
 * This file contains structure of View Credit Report
 */
export const TUC = 'TUC';
export const EQF = 'EQF';
export const EXP = 'EXP';

export const paymentStatus = {
  U: { text: 'Unknown', abbr: 'UNK' },
  C: { text: 'OK', abbr: 'OK' },
  1: { text: '30 days late', abbr: '30' },
  2: { text: '60 days late', abbr: '60' },
  3: { text: '90 days late', abbr: '90' },
  4: { text: '120 days late', abbr: '120' },
  5: { text: '150+ days late', abbr: '150' },
  7: { text: 'Payment Plan', abbr: 'PP' },
  8: { text: 'Repossession / Foreclosure', abbr: 'RF' },
  9: { text: 'Collection / Charge-Off', abbr: 'CO' },
};

export const paymentStatusEQF = {
  ...paymentStatus,
  U: { text: 'OK', abbr: 'OK' },
};

export const personalInformationTemplate = [
  { title: 'Name', field: 'Name' },
  { title: 'Also Known As', field: 'AKA' },
  { title: 'Date of Birth', field: 'DOB' },
  { title: 'Current Address', field: 'CurrentAddr' },
  { title: 'Previous Address', field: 'PreviousAddr', subField: 'address' },
  { title: 'Employer', field: 'Employer' },
  { title: 'Previous Employer', field: 'PreviousEmployer', subField: 'name' },
  { title: 'Consumer Statement', field: 'ConsumerStatement' },
];

export const accountSummaryTemplate = [
  { title: 'Credit Report Date', field: 'ReportDate' },
  { title: 'Credit Score', field: 'CreditScore' },
  { title: 'Balances', field: 'TotalBalances', fieldType: 'money' },
  { title: 'Payments', field: 'TotalMonthlyPayments', fieldType: 'money' },
  { title: 'Credit Accounts', field: 'TotalAccounts' },
  { title: 'Open Accounts', field: 'OpenAccts' },
  { title: 'Closed Accounts', field: 'CloseAccounts' },
  { title: 'Delinquent', field: 'DelinquentAccounts' },
  { title: 'Inquiries (2 years)', field: 'InquirySummary' },
  { title: 'Derogatory', field: 'DerogatoryAccounts' },
  { title: 'Public Records', field: 'PublicRecords' },
];

export const accountListTemplates = {
  account: [
    { accountName: 'Real Estate', accountIndex: 'RealEstate' },
    { accountName: 'Revolving', accountIndex: 'Revolving' },
    { accountName: 'Credit Card', accountIndex: 'CreditCard' },
    { accountName: 'Installment', accountIndex: 'Installment' },
    { accountName: 'Collections', accountIndex: 'Collection' },
    { accountName: 'Other', accountIndex: 'Other' },
    { accountName: 'Unknown', accountIndex: 'Unknown' },
  ],
  publicRecord: [
    { accountName: 'Bankruptcy', accountIndex: 'Bankruptcy' },
    {
      accountName: 'Financial Counseling',
      accountIndex: 'FinancialCounseling',
    },
    { accountName: 'Financing Statement', accountIndex: 'FinancingStatement' },
    { accountName: 'Foreclosure', accountIndex: 'Foreclosure' },
    { accountName: 'Garnishment', accountIndex: 'Garnishment' },
    { accountName: 'Legal Item', accountIndex: 'LegalItem' },
    { accountName: 'Marital Item', accountIndex: 'MaritalItem' },
    { accountName: 'Misc Public Record', accountIndex: 'MiscPublicRecord' },
    { accountName: 'Tax Lien', accountIndex: 'TaxLien' },
  ],
};

export const accountListHeaderTemplates = {
  account: [
    {
      title: 'Account Name',
      field: 'accountName',
      widthClass: 'format30',
    },
    {
      title: 'Balance',
      field: 'currentBalance',
      widthClass: 'format17 m-hide',
      fieldType: 'money',
    },
    {
      title: 'Balance Date',
      field: 'dateAccountStatus',
      widthClass: 'format17 m-hide',
    },
    {
      title: 'Monthly Payment',
      field: 'monthlyPayment',
      widthClass: 'format17 m-hide',
      fieldType: 'money',
    },
    {
      title: 'Term',
      field: 'termMonths',
      widthClass: 'format17 m-hide',
    },
  ],
  publicRecord: [
    {
      title: 'Type',
      field: 'Type',
      widthClass: 'format30 m-format21',
    },
    {
      title: 'Status',
      field: 'Status',
      widthClass: 'format20',
    },
    {
      title: 'Date Filed / Reported',
      field: 'DateFiled',
      widthClass: 'format20',
    },
    {
      title: 'Reference #',
      field: 'ReferenceNumber',
      widthClass: 'format30',
    },
  ],
};

export const accountListHeaderTitleTemplates = {
  account: [
    {
      title: 'Account Name',
      field: 'accountName',
      widthClass: 'format100',
    },
  ],
};

export const accountSummaryTemplates = {
  account: [
    { title: 'Account Number', field: 'accountNumber' },
    { title: 'Condition', field: 'accountCondition' },
    { title: 'Responsibility', field: 'responsibility' },
    { title: 'Current Balance', field: 'currentBalance', fieldType: 'money' },
    { title: 'Original Balance', field: 'highBalance', fieldType: 'money' },
    { title: 'Limit', field: 'CreditLimit', fieldType: 'money' },
    { title: 'Monthly Payment', field: 'monthlyPayment', fieldType: 'money' },
    { title: 'Last Payment', field: 'dateLastPayment' },
    { title: 'Status', field: 'PayStatus' },
    { title: 'Loan Term', field: 'termMonths' },
    { title: 'Loan Type', field: 'accountType' },
    { title: 'Opened', field: 'dateOpened' },
    { title: 'Reported', field: 'dateReported' },
    { title: 'Remarks', field: 'remarks' },
    { title: 'Creditor Information', field: 'FullContactInfo' },
  ],
  publicRecord: [
    { title: 'Type', field: 'Type' },
    { title: 'Status', field: 'Status' },
    { title: 'Date Filed', field: 'DateFiled' },
    { title: 'Date Reported', field: 'dateReported' },
    { title: 'How Filed', field: 'How Filed' },
    { title: 'Reference Number', field: 'ReferenceNumber' },
    { title: 'Date Settled', field: 'DateSettled' },
    { title: 'Date Satisfied', field: 'DateSatisfied' },
    { title: 'Date Verified', field: 'DateVerified' },
    { title: 'Closing Date', field: 'DateResolved' },
    { title: 'Closing Satisfied', field: 'ClosingSatisfied' },
    { title: 'Date Deferred', field: 'DateDeferred' },
    { title: 'Asset Amount', field: 'AssetAmount', fieldType: 'money' },
    { title: 'Released Date', field: 'DateReleased' },
    { title: 'Court', field: 'Court' },
    { title: 'Amount', field: 'Amount', fieldType: 'money' },
    { title: 'Garnishee', field: 'Garnishee' },
    { title: 'Plaintiff', field: 'Plaintiff' },
    { title: 'Action Amount', field: 'ActionAmount', fieldType: 'money' },
    { title: 'Liability', field: 'LiabilityAmount', fieldType: 'money' },
    { title: 'Exempt Amount', field: 'ExemptAmount', fieldType: 'money' },
    { title: 'Name of Spouse', field: 'NameOfSpouse' },
    { title: 'Amount Owed', field: 'TaxLienAmount', fieldType: 'money' },
    { title: 'Remarks', field: 'Remarks' },
  ],
};

export const paymentStatusTemplate = [
  { title: 'Payment Status', field: 'PayStatus' },
  { title: 'Past Due Amount', field: 'amountPastDue', fieldType: 'money' },
  { title: 'Late Payments', field: 'latePaymentsInfo' },
];

export const successPaymentStatuses = ['OK'];
export const failurePaymentStatuses = [
  '30 days late',
  '60 days late',
  '90 days late',
  '120 days late',
  '150+ days late',
  'Payment Plan',
  'Repossession / Foreclosure',
  'Collection / Charge-Off',
];
export const blankPaymentStatuses = ['Unknown'];

export const failurePaymentStatusCodes = [
  '1',
  '2',
  '3',
  '4',
  '5',
  '7',
  '8',
  '9',
];

export const BUREAUS_IMAGE = {
  [TUC]: <Image imgClass="TULogo" />,
  [EQF]: <Image imgClass="EQFLogo" />,
  [EXP]: <Image imgClass="EXPLogo" />,
};

export const potentialPaymentHistoryByGrade = {
  F: 'D',
  D: 'C',
  C: 'B',
  B: 'A',
  A: 'A',
};
